<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div class="chart-header">
  <h2 mat-dialog-title cdkFocusInitial i18n>KPI Chart</h2>
  <button mat-icon-button mat-dialog-close><mat-icon>cancel</mat-icon></button>
</div>
<mat-dialog-content>
  <app-vega-chart *ngIf="kpiChart" [spec]="kpiChart" />
  <p *ngIf="!kpiChart">The input data doesn't appear to be in the correct format.</p>
</mat-dialog-content>
